// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"a1f21d0978c8c9cf2a5c9939770241a1530795e8"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "13.5.11";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs'

import { isChunkLoadError } from '@/lib/chunkLoadError'

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  // integrations: [Sentry.replayIntegration()],
  // tracesSampleRate: 1.0,
  // debug: false,
  // replaysOnErrorSampleRate: 1.0,
  // replaysSessionSampleRate: 0.1,

  beforeSend(event, hint) {
    const error = hint.originalException as any

    // Skip errors that are marked with skipSentry flag (e.g., expected 404s)
    if (error?.skipSentry === true) {
      return null // Don't send to Sentry
    }

    // Drop stale-build chunk-load errors regardless of which capture path they
    // arrived through (window handlers, browserApiErrors, the GlobalError
    // ErrorBoundary, _error). They are expected, transient deploy-skew noise:
    // a session on a previous buildId requesting a hashed chunk that no longer
    // exists. The app recovers via a hard reload (useStaleChunkReload /
    // GlobalError); the Sentry event is non-actionable. See src/lib/chunkLoadError.ts.
    //
    // Exception: GlobalError re-reports a chunk error tagged 'exhausted' when a
    // reload was already attempted and the chunk is STILL missing — that is the
    // high-signal "genuinely broken deploy / missing asset" case, so let it
    // through for observability.
    if (isChunkLoadError(error) && event.tags?.chunk_load_recovery !== 'exhausted') {
      return null
    }

    return event
  },
})
